export { Price, type PriceProps } from './Price';
